<script setup>
import { getBrugerNotifikationDatasource } from '@/data/notifikation';
import { hasRettighed } from '@/letapps-vue/utils/auth';
import { RettighedsType } from '@/types/rettighed';
import dayjs from 'dayjs';
import { DxButton, DxPopup } from 'devextreme-vue';
import { onMounted, ref } from 'vue';

const notifikationDatasource = getBrugerNotifikationDatasource();
const brugerNotifikationer = ref([]);
const showPopup = ref(false);
const notifikationDriftMangler = ref(true);
const notifikationNyhedMangler = ref(true);

onMounted(async () => {
  //Popup vises kun til brugere, der har adgang til Rådgiversiden
  if (!hasRettighed(RettighedsType.LetguideRaadgiver)) {
    return;
  }

  let notificationsMissing = false;

  brugerNotifikationer.value = await notifikationDatasource.load();
  brugerNotifikationer.value.forEach((n) => {
    if (n.notifikationTypeId == 1) {
      notifikationNyhedMangler.value = false;
    }
    if (n.notifikationTypeId == 2) {
      notifikationDriftMangler.value = false;
    }
  });
  if (notifikationDriftMangler.value || notifikationNyhedMangler.value) {
    notificationsMissing = true;
  }

  if (notificationsMissing) {
    const now = dayjs();
    const popupLatest =
      window.localStorage.getItem('LetguidePopupLatest') || dayjs().subtract(1, 'year');
    const popupCount = parseInt(window.localStorage.getItem('LetguidePopupCount') || 0);
    const timeSinceLastPopup = now.diff(popupLatest, 'day');
    if (timeSinceLastPopup > 30 && popupCount < 3) {
      showPopup.value = true;
      window.localStorage.setItem('LetguidePopupLatest', now);
      window.localStorage.setItem('LetguidePopupCount', popupCount + 1);
    }
  }
});

const popupAttributes = {
  class: 'letguide-info-popup',
};
</script>

<template>
  <DxPopup
    v-model:visible="showPopup"
    :hide-on-outside-click="true"
    :show-title="true"
    :show-close-button="true"
    content-template="popup-content"
    :width="600"
    :height="430"
    style="background-color: red"
    :wrapperAttr="popupAttributes"
  >
    <template #popup-content>
      <div>
        <p class="letguide-info-popup-overskrift">Hold dig orienteret</p>
        <div class="letguide-info-popup-tekst">
          <p v-if="notifikationNyhedMangler && notifikationDriftMangler">
            Tilmeld dig notifikationer, og få besked, så snart der er nyheder eller driftsbeskeder.
            Det er hurtigt, nemt, og hjælper dig med at holde dig opdateret i dit arbejde.
          </p>
          <p v-if="notifikationNyhedMangler && !notifikationDriftMangler">
            Tilmeld dig notifikationer, og få besked, så snart der er nyheder. Det er hurtigt, nemt,
            og hjælper dig med at holde dig opdateret i dit arbejde.
          </p>
          <p v-if="notifikationDriftMangler && !notifikationNyhedMangler">
            Tilmeld dig notifikationer, og få besked, så snart der er vigtig information om driften.
            Det er hurtigt, nemt, og hjælper dig med at holde dig opdateret i dit arbejde.
          </p>
        </div>
        <p>
          <router-link to="/profile" @click="() => (showPopup = false)">
            <DxButton text="Tilmeld notifikationer" type="default"></DxButton>
          </router-link>
        </p>
      </div>
    </template>
    >
  </DxPopup>
</template>

<style lang="scss">
@import '@/css//variables.letguide.scss';

.letguide-info-popup {
  .dx-popup-wrapper > .dx-overlay-content {
    border-radius: 0 !important;
    border: none !important;
  }

  .dx-overlay-content {
    background-color: $letpension-sand !important;
    text-align: center;
    border-radius: 0 !important;
    border: none !important;
  }

  .dx-toolbar {
    border-bottom: none !important;
  }
}

.letguide-info-popup-overskrift {
  font-family: Marcia;
  font-size: 2.6rem;
}

.letguide-info-popup-tekst {
  font-size: 1rem;
  line-height: 1.8;
  padding: 0 20px 10px 20px;
}
</style>
